module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }